import { Tooltip } from 'antd';

export const columnsObj = {
  name: {
    title: 'Campaign',
    width: 240,
    dataIndex: 'name',
    key: 'name',
    sorter: true,
  },
  status: {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    width: 120,
  },
  daysIntoFlight: {
    title: 'Days Into Flight',
    dataIndex: 'daysIntoFlight',
    key: 'daysIntoFlight',
    width: 120,
  },
  daysLeft: {
    title: 'Days Left',
    dataIndex: 'daysLeft',
    key: 'daysLeft',
    width: 120,
    sorter: true,
  },
  daysLeftFromSchedule: {
    title: (
      <Tooltip title="Days Left From DSP Schedule">
        Schedule Days
      </Tooltip>
    ),
    dataIndex: 'daysLeftFromSchedule',
    key: 'daysLeftFromSchedule',
    width: 120,
    sorter: true,
  },
  expectedImpressions: {
    title: 'Expected Imps/Budget',
    dataIndex: 'expectedImpressions',
    key: 'expectedImpressions',
    width: 120,
  },
  actualImpressions: {
    title: 'Actual-Imps/Budget',
    dataIndex: 'actualImpressions',
    key: 'actualImpressions',
    width: 120,
    render: (text, record) => {
      return (
        <Tooltip title={text}>
          <Text>{text}</Text>
        </Tooltip>
      );
    },
  },
  impressionsLeft: {
    title: 'Imps/Budget Left',
    dataIndex: 'impressionsLeft',
    key: 'impressionsLeft',
    width: 120,
  },
  impressionsYesterday: {
    title: 'Imps/Budget Yesterday',
    dataIndex: 'impressionsYesterday',
    key: 'impressionsYesterday',
    width: 120,
  },
  dailyAvgImpressionsLeft: {
    title: 'Daily Avg Left',
    dataIndex: 'dailyAvgImpressionsLeft',
    key: 'dailyAvgImpressionsLeft',
    width: 120,
  },
  roas: {
    title: 'ROAS',
    dataIndex: 'roas',
    key: 'roas',
    width: 120,
  },
  ctr: {
    title: 'CTR',
    dataIndex: 'ctr',
    key: 'ctr',
    width: 120,
  },
  pace: {
    title: 'Pace (Today)',
    dataIndex: 'pace',
    key: 'pace',
    width: 80,
    sorter: true,
    showSorterTooltip: {
      title: `Today's Pace. (Today's Impressions * Days Remaining) + Served Impressions at start of today / Impression Goal`,
    },
  },
  paceYesterday: {
    title: (
      <Tooltip
        title={`Projected Pace. (Yesterdays Impression * Days Remaining yesterday) + Served Impressions at start of the Yesterday / Impression Goal`}
      >
        Pace (Yesterday)
      </Tooltip>
    ),
    dataIndex: 'paceYesterday',
    key: 'paceYesterday',
    width: 80,
  },
  paceTwoDaysAgo: {
    title: (
      <Tooltip
        title={`Projected Pace 2 days ago. (Impressions from 2 days ago * Days Remaining at that time) + Served Impressions up to that point / Impression Goal`}
      >
        Pace (2 days ago)
      </Tooltip>
    ),
    dataIndex: 'paceTwoDaysAgo',
    key: 'paceTwoDaysAgo',
    width: 80,
  },
  paceThreeDaysAgo: {
    title: (
      <Tooltip
        title={`Projected Pace 3 days ago. (Impressions from 3 days ago * Days Remaining at that time) + Served Impressions up to that point / Impression Goal`}
      >
        Pace (3 days ago)
      </Tooltip>
    ),
    dataIndex: 'paceThreeDaysAgo',
    key: 'paceThreeDaysAgo',
    width: 80,
  },
  paceFourDaysAgo: {
    title: (
      <Tooltip
        title={`Projected Pace 4 days ago. (Impressions from 4 days ago * Days Remaining at that time) + Served Impressions up to that point / Impression Goal`}
      >
        Pace (4 days ago)
      </Tooltip>
    ),
    dataIndex: 'paceFourDaysAgo',
    key: 'paceFourDaysAgo',
    width: 80,
  },
  paceFiveDaysAgo: {
    title: (
      <Tooltip
        title={`Projected Pace 5 days ago. (Impressions from 5 days ago * Days Remaining at that time) + Served Impressions up to that point / Impression Goal`}
      >
        Pace (5 days ago)
      </Tooltip>
    ),
    dataIndex: 'paceFiveDaysAgo',
    key: 'paceFiveDaysAgo',
    width: 80,
  },
  paceSixDaysAgo: {
    title: (
      <Tooltip
        title={`Projected Pace 6 days ago. (Impressions from 6 days ago * Days Remaining at that time) + Served Impressions up to that point / Impression Goal`}
      >
        Pace (6 days ago)
      </Tooltip>
    ),
    dataIndex: 'paceSixDaysAgo',
    key: 'paceSixDaysAgo',
    width: 80,
  },
  paceSevenDaysAgo: {
    title: (
      <Tooltip
        title={`Projected Pace 7 days ago. (Impressions from 7 days ago * Days Remaining at that time) + Served Impressions up to that point / Impression Goal`}
      >
        Pace (7 days ago)
      </Tooltip>
    ),
    dataIndex: 'paceSevenDaysAgo',
    key: 'paceSevenDaysAgo',
    width: 80,
  },
  Actions: {
    title: '',
    key: 'actions',
    width: 80,
  },
};

export const permanentKeys = [columnsObj.pace.key, columnsObj.name.key];

export const defaultColumnKeys = Object.keys(columnsObj);
